import { Component, inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
	templateUrl: "./not-found.component.html"
})
export class NotFoundComponent implements OnInit {
	private readonly router = inject(Router);

	ngOnInit() {
		if (this.router.url.startsWith("/admin")) {
			void this.router.navigate(["/admin"]);
		} else {
			void this.router.navigate([""]);
		}
	}
}
